module.exports = __webpack_public_path__ + "static/media/BebometroQr2.126e0304.png";